module.exports = "<footer>\n    <div class=\"container-fluid\">\n        <p class=\"copyright pull-right\">\n            &copy; {{test | date: 'yyyy'}} Разработано с использованием технологии <a target=\"_blank\" href=\"http://www.snrd.ru\">Снаряд</a>\n        </p>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/main/footer/footer.component.html
// module id = ../../../../../src/app/client/components/main/footer/footer.component.html
// module chunks = 0